import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import store from "../../../../store";
import { putField } from "../../../../utils/form";

export const callFreeSaleObjective = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_OBJECTIVE", value: searchQuery })
        .then(items => items.filter(item => ["1", "2"].includes(item.key)));

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.freeSale.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        /*เลข haz, tradename จาก haz */
        createColumnInput({ title: () => i18n.global.t("model.freeSale.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.freeSale.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.freeSale.refObjective"),
            dataIndex: "refObjective.value",
            customRender: ({ record }) => <div>{record.refObjective?.value}</div>,
            inputProp: () => ({ list: callFreeSaleObjective, optLabel: "value" }),
            align: "center",
            search: {
                name: "refObjective.id"
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.freeSale.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => <div>{record.refStatus?.value}</div>,
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            align: "center",
            search: {
                name: "refStatus.id"
            }
        })
    ];
    return columns;
}

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
